/** Average operations per active user, guarded against divide-by-zero. */
export const calculateAvgPerUser = (totalCount: number, activeUserCount: number): number =>
  activeUserCount === 0 ? 0 : Math.round(totalCount / activeUserCount);
